import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'
import store, { MutationName } from '@/store'

async function handleRequestSuccess(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  store.commit(MutationName.LOADING, true)
  return config
}

function handleRequestException(exception: AxiosError | Error): any {
  store.commit(MutationName.LOADING, false)
  return Promise.reject(exception)
}

async function handleResponseSuccess<T = any>(value: T): Promise<any> {
  setTimeout(() => store.commit(MutationName.LOADING, false), 500)
  return value
}

function handleResponseException(exception: AxiosError): any {
  store.commit(MutationName.LOADING, false)
  return Promise.reject(exception)
}

export function apply(instance: AxiosInstance) {
  instance.interceptors.request.use(handleRequestSuccess, handleRequestException)
  instance.interceptors.response.use(handleResponseSuccess, handleResponseException)
}
